
export default (value) => value.toLowerCase();